let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dnC20")).then(() => parcelRequire('kQ1yT'));